import rangesliderJs from 'rangeslider-js';

// Short aliases for JS selectors
const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);
// const fromId = document.getElementById.bind(document);
// const fromClass = document.getElementsByClassName.bind(document);
// const fromTag = document.getElementsByTagName.bind(document);

// Animate.CSS main function
const animateCSS = (element, animationName, callback) => {
  const node = document.querySelector(element);
  node.classList.add('animated', animationName)

  function handleAnimationEnd() {
    node.classList.remove('animated', animationName)
    node.removeEventListener('animationend', handleAnimationEnd)
    if (typeof callback === 'function') callback()
  }
  node.addEventListener('animationend', handleAnimationEnd)
}


// Append element after
Element.prototype.appendAfter = function (element) {
    element.parentNode.insertBefore(this, element.nextSibling);
}, false;



function scrollToY (y, duration = 0, element = document.scrollingElement) {
  // cancel if already on target position
  if (element.scrollTop === y) return;

  const cosParameter = (element.scrollTop - y) / 2;
  let scrollCount = 0, oldTimestamp = null;

  function step (newTimestamp) {
    if (oldTimestamp !== null) {
      // if duration is 0 scrollCount will be Infinity
      scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
      if (scrollCount >= Math.PI) return element.scrollTop = y;
      element.scrollTop = cosParameter + y + cosParameter * Math.cos(scrollCount);
    }
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}


function scrollToTop(duration = 0) {
  scrollToY(0, duration, document.scrollingElement);
}

function scrollToElement(element, duration = 0) {
	const offset = Math.round(element.getBoundingClientRect().top);
	scrollToY(document.scrollingElement.scrollTop + offset, duration);
}

document.onkeypress = function (e) {
    var evt = window.event || e;
    // alert(evt.keyCode);
    switch (evt.keyCode) {
        case 122:
            // Call your method Here
            // alert('test');
            scrollToElement(query('.testttt'), 1000);
            // scrollToY(1000, 1000);
            break;
    }
}



// Getting parent element by selector
const collectionHas = (a, b) => {
  for(var i = 0, len = a.length; i < len; i ++) {
      if(a[i] == b) return true;
  }
  return false;
}

const findParentBySelector = (elm, selector) => {
  var all = document.querySelectorAll(selector);
  var cur = elm.parentNode;
  while(cur && !collectionHas(all, cur)) { //keep going up until you find a match
      cur = cur.parentNode; //go up
  }
  return cur; //will return null if not found
}

const contentWrapper = query('.main-content-wrapper');

const instalmentsSlider = query('#input-instalments-number-slider');
const instalmentsNumber = query('#input-instalments-number');

const paymentInfoWrapper = query('.payment-info-wrapper');
const paymentInfo = query('.payment-info');
const fullPaymentInfo = query('.full-payment-info');

const paymentDesc = query('.desc-wrapper');
const protectionInfo = query('.protection-info');

const banksTypesRadio = queryAll('.bank-transfer-wrapper .form-radio-box');
const transferChannelWrapper = query('.bank-transfer-channel-container')


// Navigation between cards
queryAll('.content-card-nav-item').forEach(item => {
  item.addEventListener('click', event => {
    const activeCard = query('.content-card.shown');
    // const contentWrapper = query('.main-content-wrapper');
    const elem = event.currentTarget;
    const target = elem.dataset.target;
    const direction = elem.dataset.direction;
    const wrapperHeight = contentWrapper.getBoundingClientRect().height;
    let fadeIn = 'fadeInRight';
    let fadeOut = 'fadeOutLeft';

    if(direction == 'right'){
      fadeIn = 'fadeInLeft';
      fadeOut = 'fadeOutRight';
    }

    // if(target == '#page-bank-transfer-traditional'){
    //   event.stopPropagation()
    // }

    if (elem.dataset.transition == 'true') return false;
    elem.dataset.transition = 'true';

    event.stopPropagation()
    event.preventDefault();

    // set current wrapper height
    contentWrapper.style.height = wrapperHeight + 'px';

    // activeCard.classList.add('pos-absolute');
    // contentWrapper.style.height = '400px';

    activeCard.classList.add('pos-absolute');
    animateCSS('.content-card.shown', fadeOut, function() {
      activeCard.classList.add('d-none');
      activeCard.classList.remove('pos-absolute');
      activeCard.classList.remove('shown');
    })

    query(target).classList.remove('d-none');
    const targetHeight = query(target).getBoundingClientRect().height;

    // set new wrapper height from target card
    contentWrapper.style.height = targetHeight + 'px';

    animateCSS(target, fadeIn, function() {
      query(target).classList.add('shown');
    })

    setTimeout(function(){
      contentWrapper.style.height = 'auto';
      elem.dataset.transition = 'false';
    }, 800);


    // Instalments range slider init
    if(target == '#page-instalments' && !instalmentsSlider.hasAttribute('min')){
      rangesliderJs.create(instalmentsSlider, {
        min:4,
        max: 24,
        value: 6,
        step: 1,
        onSlide: val => instalmentsNumber.setAttribute('value', val)
      });
    }
  }, false);
});


// Full checkbox text
queryAll('.partially-hidden-toggle').forEach(item => {
  item.addEventListener('click', event => {
    const target = event.currentTarget;
    const parent = target.parentNode;
    const label = parent.children[2];
    const labelHeight = label.getBoundingClientRect().height;

    parent.classList.toggle('shown');
    parent.style.height = labelHeight + 'px';

    setTimeout(function(){
      parent.style.height = 'auto';
    }, 400);

    // console.log(labelHeight);
  });
});


// Full payment info
queryAll('.full-payment-info-toggle').forEach(item => {
  item.addEventListener('click', event => {
    const target = event.currentTarget;
    const parent = target.parentNode;
    const infoHeight = paymentInfo.getBoundingClientRect().height;

    paymentInfoWrapper.style.height = infoHeight + 'px';

    paymentInfo.classList.add('pos-absolute');
    animateCSS('.payment-info', 'fadeOutDown', function() {
      paymentInfo.classList.add('d-none');
      paymentInfo.classList.remove('pos-absolute');
    })

    fullPaymentInfo.classList.remove('d-none');
    const fullInfoHeight = fullPaymentInfo.getBoundingClientRect().height;
    paymentInfoWrapper.style.height = fullInfoHeight + 'px';

    animateCSS('.full-payment-info', 'fadeInUp', function() {
      paymentInfoWrapper.style.height = 'auto';
    })
  });
});


// Bank transfer - scroll after channel select
queryAll('.bank-transfer-wrapper .channel-type-box').forEach(item => {
  item.addEventListener('click', event => {
    const target = event.currentTarget;
    const parent = target.parentNode;


    const offset = Math.round(query('.bank-transfer-form').getBoundingClientRect().top) - 100;
  	scrollToY(document.scrollingElement.scrollTop + offset, 1000);
    // console.log('test');
  });
});



queryAll('.bank-transfer-wrapper .form-radio-box').forEach(item => {
  item.addEventListener('click', event => {
    const target = event.currentTarget;
    const parent = target.parentNode;
    const index = [...item.parentElement.children].indexOf(item);
    const width = window.innerWidth;
    let appendIndex = 0;

    parent.classList.add('selected');

    // getting index of the last element in the row
    if(width >= 576){
      switch(true){
        case index <= 3: appendIndex = 3; break;
        case index <= 7: appendIndex = 7; break;
        case index <= 11: appendIndex = 11; break;
        case index <= 15: appendIndex = 15; break;
        case index <= 19: appendIndex = 19; break;
      }
    } else {
      switch(true){
        case index <= 2: appendIndex = 2; break;
        case index <= 5: appendIndex = 5; break;
        case index <= 8: appendIndex = 8; break;
        case index <= 11: appendIndex = 11; break;
        case index <= 14: appendIndex = 14; break;
        case index <= 17: appendIndex = 17; break;
      }
    }

    transferChannelWrapper.classList.add('not-shown');
    transferChannelWrapper.appendAfter(banksTypesRadio[appendIndex]);
    transferChannelWrapper.classList.remove('d-none');
    setTimeout(function(){
      transferChannelWrapper.classList.remove('not-shown');
    }, 50);
  });
});


queryAll('.protection-checkbox').forEach(item => {
  item.addEventListener('change', event => {
    const checked = event.target.checked;

    if (checked) {
      paymentDesc.classList.add('shown');
    } else {
      paymentDesc.classList.remove('shown');
    }

    queryAll('.protection-info').forEach(item => {
      if (checked) {
        item.classList.add('shown');
      } else {
        item.classList.remove('shown');
      }
    });

    queryAll('.protection-checkbox').forEach(item => {
      item.checked = checked;
    });
  });
});



// ====================================================

console.log(
  '%c Powered by Paybylink.pl 🤟',
  'background: #0167aa; color: #ffffff'
);
